export const fbStatus = {
  connected: 'connected',
};

export const oAuthSdkStates = {
  loading: 'loading',
  success: 'success',
  error: 'error',
};

export const pairAuthFlows = {
  pin: 'pin',
  qr: 'qr',
};
